import { useRef, useState, useEffect } from 'react'
import { motion, useScroll, useTransform } from 'framer-motion'
import womanImg from '../images/Parallax1.webp'
import { WomanContainer } from './styled'
const Woman = () => {
  const ref = useRef(null)
  const [isDesktop, setIsDesktop] = useState<boolean>(false)
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ['end end', 'start start'],
  })

  const move = useTransform(
    scrollYProgress,
    [0, 0.5, 1],
    ['60vw', '30vw', '0vw']
  )
  const rotate = useTransform(
    scrollYProgress,
    [0, 0.25, 0.5, 0.75, 1],
    ['0deg', '10deg', '0deg', '10deg', '0deg']
  )
  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth > 1024)
    }

    handleResize() // set initial value
    window.addEventListener('resize', handleResize)

    return () => window.removeEventListener('resize', handleResize)
  })

  return (
    <WomanContainer ref={ref}>
      <motion.div
        style={{
          width: 'fit-content',
          transformOrigin: 'center',
          translateX: !isDesktop ? move : '0vw',
          rotate: !isDesktop ? rotate : '0deg',
        }}
      >
        <img src={womanImg} alt="woman" />
      </motion.div>
    </WomanContainer>
  )
}
export default Woman
